import { housesSlice } from './slice';

export const housesReducer = housesSlice.reducer;
export { default as housesActions } from './actions';
export * as housesSelectors from './selectors';
